export default [
  {
    path: "/unautorized",
    component: () => import("@/views/errors/UnauthorizedError.vue"),
  },
];
